/**
 * Dashboard Redesign + SPOC Visibility — frontend-side tile constants.
 * Cites: .claude/design/dashboard-redesign.md ("Tile catalog", §A.4).
 *
 * The tile registry lives in the backend (services/dashboard/tileRegistry.ts) — this file does NOT
 * mirror the tile catalog. It only carries display labels for the 6 tile categories and the stage
 * names, used to group tiles into sections on both ProjectDashboard.jsx (in-app) and SharedDashboardPage.jsx (public).
 */

export const DASHBOARD_CATEGORY_LABELS = {
  gap: 'Gap analysis',
  risk: 'Risk',
  control: 'Control implementation',
  evidence: 'Evidence & monitoring',
  audit: 'Internal audit',
  governance: 'Governance',
};

/**
 * Workflow stage numbers that gate dashboard tiles (backend services/dashboard/stageGate.ts) -> the
 * stage name shown to staff on a `stage_not_reached` tile (CLAUDE.md section 4).
 */
export const DASHBOARD_STAGE_NAMES = {
  4: 'Gap analysis (report pushed to the dashboard)',
  6: 'Risk analysis',
  7: 'Control implementation',
  8: 'Evidencing & monitoring',
  9: 'Internal audit',
};

// Single shared formatter (Commandment XII) — see utils/formatDdMmYyyy.js.
export { formatDdMmYyyy } from '../utils/formatDdMmYyyy';
